import React, { useEffect, useState } from "react";

import { ReactComponent as RightArrow } from "../../../../assets/appearencePage/arrow-right.svg";
import { ReactComponent as RightArrowDark } from "../../../../assets/appearencePage/arrow-right-dark.svg";
import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { ReactComponent as LockIconDark } from "../../../../assets/MainPage/addBlock/lock-dark.svg";
import { ReactComponent as LockIcon } from "../../../../assets/MainPage/addBlock/lock.svg";

import BackgroundIcon from "../../../../assets/appearencePage/galleryEdit.png";
import FavIcon from "../../../../assets/appearencePage/favIcon.png";
import TextIcon from "../../../../assets/appearencePage/textIcon.png";
import BrandingIcon from "../../../../assets/appearencePage/brandingIcon.png";
import SeoIcon from "../../../../assets/appearencePage/seoIcon.png";
import AvatarIcon from "../../../../assets/appearencePage/avatarIconLight.png";
import LinkIcon from "../../../../assets/appearencePage/linkIcon.png";
import { Link, useNavigate } from "react-router-dom";
import useLocales from "../../../../hooks/useLocales";
import useSettings from "../../../../hooks/useSettings";
import { useSelector } from "react-redux";

const Lists = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [width, setWidth] = useState(window.innerWidth);
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  const paidUserCheck = paymenetBlocks === 1;

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="flex md:hidden mt-10 mb-[38px] relative items-center px-6">
        <div className="absolute start-6 inset-y-0 flex items-center justify-center">
          <Link to={"/mDashboard"}>
            {darkMode ? (
              <LeftArrowDark
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </Link>
        </div>
        <h6 className="w-full text-center text-heading_color text-body_copy1_b dark:text-color_v1_dark">
          {/* Appearance */}
          {translate("cms.appearance")}
        </h6>
      </div>
      <div className="px-6 md:hidden flex flex-col gap-5 mb-[38px]">
        <Link to={"background"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #754A9133`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#754A91] to-[#54008A]`}
                >
                  <img
                    className={`h-full w-full`}
                    src={BackgroundIcon}
                    alt=""
                  />
                </div>
              </div>
              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Background */}
                {translate("background")}
              </div>
              <div className="text-xl ">
                {darkMode ? (
                  <RightArrowDark
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <RightArrow
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
        <Link to={"favicon"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #FF784255`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br  from-[#FF7842] to-[#EA4C0E]`}
                >
                  <img className={`h-full w-full`} src={FavIcon} alt="" />
                </div>
              </div>
              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Favicon */}
                {translate("favicon")}
              </div>

              <div className="text-xl ">
                {darkMode ? (
                  <RightArrowDark
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <RightArrow
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
        <Link to={"font"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #0CA8F655`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#0CA8F6] to-[#0096E1]`}
                >
                  <img className={`h-full w-full`} src={TextIcon} alt="" />
                </div>
              </div>
              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Fonts */}
                {translate("fonts")}
              </div>

              <div className="text-xl ">
                {darkMode ? (
                  <RightArrowDark
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <RightArrow
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
        <Link to={paidUserCheck ? "branding" : "#"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #3ACE0155`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#3ACE01] to-[#36C300]`}
                >
                  <img className={`h-full w-full`} src={BrandingIcon} alt="" />
                </div>
              </div>
              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Branding */}
                {translate("branding")}
              </div>
              <div className="text-xl ">
                {darkMode ? (
                  <>
                    {paidUserCheck ? (
                      <RightArrowDark
                        className={` ${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <LockIconDark />
                    )}
                  </>
                ) : (
                  <>
                    {paidUserCheck ? (
                      <RightArrow
                        className={` ${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <LockIcon />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </Link>
        <Link to={"seo"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #FF519055`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#FF5190] to-[#D7155B]`}
                >
                  <img className={`h-full w-full`} src={SeoIcon} alt="" />
                </div>
              </div>

              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Seo */}
                {translate("cms.seo")}
              </div>

              <div className="text-xl cursor-pointer">
                {darkMode ? (
                  <RightArrowDark
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <RightArrow
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
        <Link to={"avatarAppearance"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #32323255`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#323232] to-[#000000]`}
                >
                  <img className={`h-full w-full`} src={AvatarIcon} alt="" />
                </div>
              </div>

              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Avatar */}
                {translate("avatar")}
              </div>

              <div className="text-xl cursor-pointer">
                {darkMode ? (
                  <RightArrowDark
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <RightArrow
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
        <Link to={"linksAppearance"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #F452FF55`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#F452FF] to-[#832BC1]`}
                >
                  <img className={`h-full w-full`} src={LinkIcon} alt="" />
                </div>
              </div>

              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {/* Link */}
                {translate("link")}
              </div>

              <div className="text-xl cursor-pointer">
                {darkMode ? (
                  <RightArrowDark
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <RightArrow
                    className={` ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          </div>
        </Link>
        {/* <Link to={"HeaderTextAppearance"}>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] p-2 pr-[13px] ">
            <div className="flex  gap-2 justify-between items-center cursor-pointer">
              <div className="p-[5px]">
                <div
                  style={{
                    boxShadow: `-2px 3px 7px #F452FF55`,
                  }}
                  className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#F452FF] to-[#832BC1]`}
                >
                  <img className={`h-full w-full`} src={LinkIcon} alt="" />
                </div>
              </div>

              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
               
                {translate("link")}
              </div>

              <div className="text-xl cursor-pointer">
                <RightArrow
                  className={` ${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              </div>
            </div>
          </div>
        </Link> */}
      </div>
    </>
  );
};

export default Lists;
